import { useContext } from "react";

import { AuthContext } from "src/context/AuthContext";
import AppShell from "src/features/MiniCRM/Workspace/layout/AppShell";
import WorkspaceEntryPage from "src/features/MiniCRM/Workspace/pages/WorkspaceEntryPage";
import ProtectedRoute from "./ProtectedRoute";

function WorkspaceAccessGate({ element }) {
  const { currentUser } = useContext(AuthContext);

  if (!currentUser?.local_workspace_id) {
    return (
      <AppShell>
        <WorkspaceEntryPage />
      </AppShell>
    );
  }

  return element;
}

export default function WorkspaceRequiredRoute({ element }) {
  return <ProtectedRoute element={<WorkspaceAccessGate element={element} />} />;
}
